export const POSTHOG_PROXY_PATH = '/hzn';
export const POSTHOG_EU_HOST = 'https://eu.i.posthog.com';
export const POSTHOG_EU_UI_HOST = 'https://eu.posthog.com';

export const ANALYTICS_OPT_OUT_COOKIE = 'aa_analytics_opt_out';
export const ANALYTICS_OPT_OUT_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export const APPLICATION_DISTINCT_ID_PREFIX = 'app_';

export const ALLOWED_UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

export const STATIC_FIRST_SEGMENTS = [
  'agb',
  'barrierefreiheit',
  'datenschutz',
  'finished',
  'impressum',
  'invalid',
  'nebenkosten-mieter',
  'nebenkosten-vermieter',
  'schaden',
  'so-funktionierts',
  'starterkit',
  'starterkit-aak',
  'unknown',
  'werte',
  'wissensplattform',
  'wissensplattform-aak',
] as const;

export const RESULT_FIRST_SEGMENTS = ['finished', 'unknown', 'invalid'] as const;
